var React = require('react');

function HeartFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M43.8151 5.47008C42.3534 2.81314 33.1899 -6.08388 22.5673 6.79727C11.4117 -6.08388 2.77863 2.81314 1.31948 5.47008C-1.33745 10.383 0.2562 17.8209 3.97642 21.4066L22.5698 40L41.1633 21.4066C44.8784 17.8209 46.4721 10.3855 43.8152 5.47008H43.8151Z","fill":"black"}));
}

HeartFilled.defaultProps = {"width":"46","height":"40","viewBox":"0 0 46 40","fill":"none"};

module.exports = HeartFilled;

HeartFilled.default = HeartFilled;
